import React from "react";
import {Button, Label, ListBox, ListBoxItem, Popover, Select, SelectValue, Text} from "react-aria-components";
import {LuChevronDown} from "react-icons/lu";
import "./DefaultDropButton.css";
import WrappedWithErrorMessage from "../../ErrorMessage/ErrorMessage.jsx";

function DefaultDropButton({name, buttonText, selected, options, label, hideLabel, onSelect, disabled, secondary, className, customStyle, errorLoc} : {
    name: string,
    buttonText?: string,
    selected?: string,
    options: string[],
    label: string,
    hideLabel?: boolean,
    onSelect?: (text: string) => void,
    disabled?: boolean,
    secondary?: boolean,
    className?: string,
    customStyle?: any,
    errorLoc: string[],
}) {
    const [isOpen, setIsOpen] = React.useState(false);

    if (customStyle === undefined) {
        customStyle = {}
    }

    function optionSelected(text) {
        onSelect(text)
        setIsOpen(false)
    }

    const optionElements = [];
    if(options){
        for (let i = 0; i < options.length; i++) {
            optionElements.push(<ListBoxItem
                key={i}
                aria-label={options[i]}
                onAction={() => optionSelected(options[i])}
                className={"DropButtonListBoxItem "+options[i]}
                textValue={options[i]}
            >
                {options[i]}
            </ListBoxItem>)
        }
    }

    let labelElement = null;
    let labelClassname =  "DefaultDropButtonLabel"
    if (disabled) {
        labelClassname = labelClassname + " disabled"
    }
    if(label && !hideLabel){
        labelElement = <Label aria-label={label} className={labelClassname} id={label}>{label}</Label>
    }

    let classname = "labeledDefaultDropButton";
    if(secondary){
        classname = classname + " Secondary"
    }

    let cl = "DefaultDropButton";
    if(className){
        cl = cl + " " + className
    }
    if(label){
        cl = cl + " " + label
    }
    if (disabled) {
        cl = cl + " disabled"
    }
    return <div className={classname} style={customStyle}>
        {labelElement}
        <WrappedWithErrorMessage errorLoc={errorLoc} disabled={disabled}>
                <Select
                    className={cl}
                    name={name}

                    slot="select"
                    isDisabled={disabled}
                    aria-labelledby={label}
                    style={customStyle}
                >
                    <Button
                        aria-label={label}
                        onPress={() => {
                            setIsOpen(!isOpen)
                        }}
                        slot="button"
                        style={customStyle}
                    >
                        {buttonText && selected === undefined ?
                            <Text className="DropButtonText" aria-label={label} slot="description">{buttonText}</Text>
                            :
                            <Text className="DropButtonText" aria-label={label} slot="description">
                                <SelectValue>{selected}</SelectValue>
                            </Text>
                        }
                        <LuChevronDown className="dropdown-arrow"/>
                    </Button>
                    <Popover
                        aria-label={label}
                        className="secondaryButtonDropdownPopover"
                        placement="bottom right"
                        isOpen={isOpen}
                        onOpenChange={(open) => setIsOpen(open)}
                    >
                        <ListBox className="DropButtonListBox" aria-label={label} selectionMode="single">
                            {optionElements}
                        </ListBox>
                    </Popover>
                </Select>
        </WrappedWithErrorMessage>
    </div>
}

export default DefaultDropButton;